module.exports = __webpack_public_path__ + "img/icon-fingerprint.37bce102.svg";